/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getDeepValue as t } from "./object.js";
var e = /\{([^\}]+)\}/g;

function n(t) {
  return null == t ? "" : t;
}

function r(r, o) {
  return r.replace(e, "object" == typeof o ? function (e, r) {
    return n(t(r, o));
  } : function (t, e) {
    return n(o(e));
  });
}

function o(t, e) {
  return t.replace(/([\.$?*|{}\(\)\[\]\\\/\+\-^])/g, function (t) {
    return e && -1 !== e.indexOf(t) ? t : "\\".concat(t);
  });
}

function c(t) {
  var e = 0;

  for (var _n = 0; _n < t.length; _n++) {
    e = (e << 5) - e + t.charCodeAt(_n), e |= 0;
  }

  return e;
}

function u(t) {
  return new DOMParser().parseFromString(t || "", "text/html").body.innerText || "";
}

export { o as escapeRegExpString, c as numericHash, r as replace, u as stripHTML };